import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import Select2Multiple from 'v-select2-multiple-component';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css'
import CONFIG from "@/assets/js/config.js";
import axios from 'axios';
import store from '@/store';
import ValidationService from '@/services/ValidationService';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "paymentList",
  components: {
    MainLayout,
    Loading,
    CONFIG,
    flatPickr,
    AdvancedLaravelVuePaginate,
    Select2Multiple,
  },

  mixins: [ValidationService],

  data() {
    return {
      paymentData: {},
      campusId: store.state.user.campus_id,
      paymentMethodArr: null,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      isFilterOpen: false,
      isLoading: false,
      searchData: {
        acaYear: this.$store.state.academicYear,
        class_id: null,
      },
      academicYearArr: null,
      currentYearId: '',
      isSearch: 0,
      payMethod: [],
      itemArr: [],
      classArr: null,
      totalReceivedAmount: 0,
      totalRequestedAmount: 0,
      search_status: false,
      searchedData: null,
      isSearched: false,
    };
  },

  computed: {
    paymentOptions() {
      return CONFIG.PAYMENT_STATUSES_OPTIONS.filter(opt => [
        CONFIG.PAYMENT_STATUS.STATUS_APPROVED,
        CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST,
      ].includes(opt.id)
      );
    }
  },

  methods: {
    getClass($yearId) {
      this.searchData.class_id = null;
      axios.get("class/classList/" + $yearId, {
        params: {
          campus_id: this.$store.state.user.campus_id,
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Class'
          }];
          this.classArr = $defaultSelectOption.concat(res.data);
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
    getItem() {
      axios.get('item/getItemForPayment')
        .then(res => {
          this.itemArr = res.data.data;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getPaymentMethod() {
      axios.get('getPaymentMethod')
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select Payment Method'
          }];
          this.paymentMethodArr = $defaultSelectOption.concat(res.data);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    getPayment(page = 1) {
      this.search_status = false;
      axios.get('payment/list?page=' + page, {
        params: {
          campus_id: this.campusId,
        }
      })
        .then(res => {
          if (res.data) {
            this.paymentData = res.data;
            this.totalRequestedAmount = this.paymentData.data.totalRequestedAmount;
            this.totalReceivedAmount = this.paymentData.data.totalReceivedAmount;
            this.isLoading = false;
          }
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.delete(id);
      } else {
        console.log("no");
      }
    },

    delete(id) {
      this.isLoading = true;
      axios.post(`payment/delete/${id}` + '/' + store.state.user.campus_id)
        .then(res => {
          this.isLoading = false;
          if (res.data) {
            this.getPayment();
            this.$notification.success('Payment Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    searching(page = 1) {
      this.search_status = true;
      this.clearValidationErrors();
      this.isSearch = 1;
      this.isLoading = true;
      if (this.searchData.p_method == 0) {
        this.searchData.p_method = undefined;
      }
      const params = {
        stuName: this.searchData.stuName,
        guardian1Name: this.searchData.guardian1Name,
        item_id: this.searchData.item_id,
        fromAmt: this.searchData.fromAmt,
        toAmt: this.searchData.toAmt,
        p_method: this.searchData.p_method,
        startDate: this.searchData.startDate,
        endDate: this.searchData.endDate,
        acaYear: this.searchData.acaYear,
        classId: this.searchData.class_id,
        invoiceNumber: this.searchData.invoiceNumber,
        status: this.searchData.status,
        campus_id: this.campusId,
        search: true,
      };
      this.searchedData = {
        ...params,
        is_search: 1,
        currentYear: this.currentYearId,
      };
      this.isSearched = true;
      axios.get('payment/search?page=' + page, {
        params
      })
        .then((res) => {
          if (res.data) {
            this.paymentData = res.data;
            this.totalRequestedAmount = this.paymentData.data.totalRequestedAmount;
            this.totalReceivedAmount = this.paymentData.data.totalReceivedAmount;
            this.isLoading = false;
          }
        }).catch(error => {
          this.printValidationError(error.response);
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    reset() {
      this.searchData = [];
      this.isLoading = true;
      this.getPayment();
      this.isSearched = false;
    },

    getThisAcademicYear() {
      this.isLoading = true;
      axios.get('period/getThisPeriod')
        .then(res => {
          this.currentYearId = res.data.id;
          this.isLoading = false;
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    excelDownload() {
      this.isLoading = true;
      const params = this.isSearched && this.searchedData
        ? { ...this.searchedData }
        : {
          campus_id: this.campusId,
          currentYear: this.currentYearId,
          is_search: this.isSearch
        };
      axios.get('/payment/excelDownload', {
        params,
        responseType: 'arraybuffer'
      })
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement('a');
          let date = new Date();
          fileLink.href = fileURL;
          fileLink.setAttribute('download', `payment_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.searching,
        listFn: this.getPayment
      })
    },

    getStatusClass(status) {
      switch (status) {
        case CONFIG.PAYMENT_STATUS.STATUS_ADMIN_REQUEST:
          return 'bg-secondary';
        case CONFIG.PAYMENT_STATUS.STATUS_APPROVED:
          return 'bg-success';
        default:
          return 'bg-light';
      }
    },

    filterReceivedAmount(field) {
      let value = this.searchData[field];

      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');

      this.searchData[field] = value ? parseInt(value) : null;
    },
  },

  mounted() {
    this.isLoading = true;
    this.isSearch = 0;
    this.getPaymentMethod();
    this.getThisAcademicYear();
    this.getItem();
    this.getAcademicYear();
    this.getPayment();
  },
};
